/**
 * Coordinates carried over from an Address Book record into a new task.
 *
 * The record's stored point is only valid for the record's own address. If
 * dispatch picks a saved location and then edits the address text (a different
 * suite, building or street), sending the old point would make the driver
 * geofence enforce the WRONG place -- Maps would route to the typed address
 * while the app insisted the driver was "not at" the saved one. So the point is
 * only seeded while the task's address still matches the record; otherwise the
 * backend geocodes the address that is actually on the task.
 */

const normalize = (s) =>
  String(s || "")
    .toLowerCase()
    .replace(/[.,#]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

/** The one-line address Create Task fills in when a saved location is chosen. */
export function savedLocationAddress(loc) {
  if (!loc) return "";
  const street = [loc.address_line_1, loc.address_line_2].filter(Boolean);
  const cityStateZip = [loc.city, loc.state, loc.postal_code].filter(Boolean).join(", ");
  return [...street, cityStateZip].filter(Boolean).join(", ");
}

const validCoord = (v, limit) => {
  if (v === null || v === undefined || v === "" || typeof v === "boolean") return null;
  const n = Number(v);
  return Number.isFinite(n) && Math.abs(n) <= limit ? n : null;
};

/**
 * @param {object|null} location   selected Address Book record
 * @param {string} formAddress     the address text currently on the task
 * @param {"pickup"|"dropoff"} prefix
 * @returns {object} e.g. { pickupLat, pickupLng } or {} when it must not be seeded
 */
export function seededStopCoords(location, formAddress, prefix) {
  if (!location) return {};
  const lat = validCoord(location.latitude, 90);
  const lng = validCoord(location.longitude, 180);
  if (lat === null || lng === null) return {};
  if (normalize(formAddress) !== normalize(savedLocationAddress(location))) return {};
  return { [`${prefix}Lat`]: lat, [`${prefix}Lng`]: lng };
}
